import React from 'react'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import FormField from 'components/FormField'
import { LeadAvailabilityCheckForm } from 'types/interfaces'
import LeadAvailabilityCheckFormError from 'errors/LeadAvailabilityCheckFormError'
import { Role } from 'types/types'

interface LeadAvailabilityCheckFieldsProps {
  form: LeadAvailabilityCheckForm
  error?: LeadAvailabilityCheckFormError
  updateForm: (name: string, value: any) => void
  hidePostcode?: boolean
}

const ROLES: { value: Role; label: string }[] = [
  { value: 'dental nurse', label: 'Dental Nurse' },
  { value: 'hygienist', label: 'Hygienist' },
]

const LeadAvailabilityCheckFields: React.FC<LeadAvailabilityCheckFieldsProps> = ({ form, error, updateForm, hidePostcode }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <FormField
        label="Date"
        type="date"
        value={form.date ?? ''}
        onChange={(e) => updateForm('date', e.target.value)}
        errors={error?.date}
        InputLabelProps={{ shrink: true }}
      />
      <FormField
        label="Start Time"
        type="time"
        value={form.start_time ?? ''}
        onChange={(e) => updateForm('start_time', e.target.value)}
        errors={error?.start_time}
        InputLabelProps={{ shrink: true }}
      />
      <FormField
        label="End Time"
        type="time"
        value={form.end_time ?? ''}
        onChange={(e) => updateForm('end_time', e.target.value)}
        errors={error?.end_time}
        InputLabelProps={{ shrink: true }}
      />
      <FormField
        label="Lunch Break"
        type="number"
        value={form.lunch_break ?? ''}
        onChange={(e) => updateForm('lunch_break', e.target.value ? Number(e.target.value) : undefined)}
        errors={error?.lunch_break}
        helperText="Unpaid break duration in minutes"
      />
      <FormField
        label="Role"
        select
        value={form.role ?? ''}
        onChange={(e) => updateForm('role', e.target.value)}
        errors={error?.role}
      >
        {ROLES.map((r) => (
          <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
        ))}
      </FormField>
      {!hidePostcode && (
        <FormField
          label="Postcode"
          value={form.postcode ?? ''}
          onChange={(e) => updateForm('postcode', e.target.value)}
          errors={error?.postcode}
          helperText="Your practice postcode — we'll match nurses nearby"
        />
      )}
      {/* specialist feature not yet live */}
      {/* <SwitchField
        label="Sedation Required"
        value={form.sedation_required ?? false}
        onChange={(value) => updateForm('sedation_required', value)}
      />
      <SwitchField
        label="Radiography Required"
        value={form.radiography_required ?? false}
        onChange={(value) => updateForm('radiography_required', value)}
      />
      <SwitchField
        label="Implant Experience Required"
        value={form.implant_required ?? false}
        onChange={(value) => updateForm('implant_required', value)}
      />
      <SwitchField
        label="Orthodontics Experience Required"
        value={form.orthodontics_required ?? false}
        onChange={(value) => updateForm('orthodontics_required', value)}
      /> */}
    </Box>
  )
}

export default LeadAvailabilityCheckFields
